import React from "react";
import "./LegalPages.css";

function TermsOfService() {
  return (
    <div className="legal-page-wrapper">
      {/* Hero Banner */}
      <section className="legal-hero" style={{
    backgroundImage: "url('/images/bread.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}>
        <div className="hero-overlay-mask"></div>
        <div className="hero-content-box">
          <h1 className="hero-main-title" style={{
    textAlign: "center"
  }}>Terms of Service</h1>
          <div className="hero-breadcrumb">
            <span className="breadcrumb-link">Home</span>
            <span className="breadcrumb-arrow">➔</span>
            <span className="breadcrumb-current">Terms of Service</span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-main-section">
        <div className="legal-container">
          <div className="legal-document-card">
            <div className="document-header">
              <span className="meta-date">Effective Date: January 2024</span>
              <h2>Operational Rules &amp; Engagement Regulations</h2>
              <p className="lead-text">
                Please read these terms carefully before utilizing our portal, submitting contributions, or joining our grassroots outreach networks.
              </p>
            </div>

            <div className="document-body">
              <h3>1. Acceptance of Terms</h3>
              <p>
                By accessing the Anuk Charitable Trust website domain, submitting forms, or transferring financial resources, you agree to be bound by these institutional terms. If you disagree with any parameter, please refrain from executing actions on this platform.
              </p>

              <h3>2. Donation &amp; Refund Stipulations</h3>
              <p>
                All donations made to Anuk Charitable Trust are deployed directly toward ongoing grassroots welfare, education initiatives, and medical relief. Due to the rapid allocation of real-world essentials, <strong>donations are generally considered non-refundable</strong>. However, if a duplicate transaction occurs due to technical gateway latency, verifiable refund requests processed within 48 hours will be honored.
              </p>

              <h3>3. Intellectual Property Rights</h3>
              <p>
                All digital media, text archives, impact reports, photographic records, and visual branding displayed on this portal remain the exclusive proprietary property of Anuk Charitable Trust. Unauthorized commercial duplication or misrepresentation is strictly actionable under legal frameworks.
              </p>

              <h3>4. Volunteer Code of Conduct</h3>
              <p>
                Registered volunteers serve as trusted regional representatives. Engagement requires strict adherence to institutional values, absolute respect for community dignity, and zero tolerance for discrimination or exploitation during field operations.
              </p>

              <h3>5. Limitations of Liability</h3>
              <p>
                While we continuously verify and audit all published metrics, the Trust is not liable for secondary damages arising from temporary portal downtime, third-party link redirections, or external banking service outages.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TermsOfService;